import { FEATURE_FLAGS } from "@/data/globals";
import { isFeatureEnabled } from "@/env";
import { SPECIAL_SETTINGS } from "../calc/Calculator";

const ENABLE_V360 = isFeatureEnabled(FEATURE_FLAGS.V3_6);

const ruleTransforms = [
  {
    regex: /pick (\w+) (friendly|enemy) (units?) (within \d+..*), which (.*)/gim,
    getReplacer: (settings: any) =>
      function (str, count, alignment, target, within, effect) {
        const countNum = parseInt(count) || 1;
        const newValue = ENABLE_V360 ? countNum * 3 : countNum + 3;
        const plural = newValue > 1;
        return `pick ${plural ? "up to " : ""}${newValue} ${alignment} unit${plural ? "s" : ""} ${within}, which ${effect}`;
      }
  },
  {
    regex: /this model and (its|his|her) unit/gim,
    getReplacer: (settings: any) => {
      const skirmishBuffSize = settings?.[SPECIAL_SETTINGS.AuraSizes]?.["skirmishAuraBuffUnitCount"];
      const affectCount = skirmishBuffSize ? skirmishBuffSize - 1 : 3;

      // -1 due to "this model" counting as 1
      return `this model${ENABLE_V360 ? "'s unit" : ""} and up to ${affectCount} friendly units picked before the start of the game`;
    },
    append: ` If this model is killed, picked models that are deployed lose the rule.`
  },
  {
    regex: /against units where most models have Tough\(\d+\) (?:or more|or higher|to Tough\(\d+\))/gim,
    replace: `against non-Hero units with Tough(3) or more`
  }
];

if (ENABLE_V360) {
  ruleTransforms.push({
    regex: /Tough\((\d+)\)/gi,
    getReplacer: (_settings: any) => (str, tough) => `Tough(${parseInt(tough) * 3})`
  });
}

export default function skirmifyRulesText(text: string, calcSettings: any) {
  for (const ruleTransform of ruleTransforms) {
    if (ruleTransform.regex.test(text)) {
      const replace = ruleTransform.replace || ruleTransform.getReplacer(calcSettings);
      const newRule = text.replace(ruleTransform.regex, replace as any) + (ruleTransform.append ?? "");

      return newRule[0].toUpperCase() + newRule.slice(1);
    }
  }

  return text;
}
